import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { firebaseAppConfig } from '../config';
import { initializeApp } from 'firebase/app';

import { NotificationsProvider } from 'services/notification';
import { AuthProvider } from 'services/auth';
import { APIProvider } from 'services/api';
import { ColorModeProvider } from './ColorModeContext';
import { LoadingProvider } from './LoadingContext';
import { ErrorProvider } from './ErrorContext';

export const AppContext = createContext({});

export const AppProvider = ({ children }) => {
    const [app, setApp] = useState(null);

    useEffect(() => {
        setApp(initializeApp(firebaseAppConfig));
    }, []);

    return (
        <ErrorProvider>
            <AppContext.Provider value={app}>
                <AuthProvider>
                    <APIProvider>
                        <ColorModeProvider>
                            <LoadingProvider>
                                <NotificationsProvider>
                                    {children}
                                </NotificationsProvider>
                            </LoadingProvider>
                        </ColorModeProvider>
                    </APIProvider>
                </AuthProvider>
            </AppContext.Provider>
        </ErrorProvider>
    );
};

AppProvider.propTypes = {
    children: PropTypes.node,
};

export const useApp = () => useContext(AppContext);
